import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import GfrcQcPipelineCard from "../components/GfrcQcPipelineCard";
import QcPostChecksCard from "../components/QcPostChecksCard";
import FinalQcPipelineCard from "../components/FinalQcPipelineCard";
import FinalQcAnalytics from "../components/FinalQcAnalytics";

export default function QCPipeline() {
  const { user } = useAuth();
  const isAdmin = user?.role_name === "Administrator" || user?.role === "admin";
  const plantScope = String(user?.plant_scope || "BOTH").toUpperCase();
  const canSeeSLC = isAdmin || plantScope === "SLC" || plantScope === "BOTH";
  const canSeeMex = isAdmin || plantScope === "MEX" || plantScope === "BOTH";
  const [showMexicoState, setShowMexico] = useState(() => !canSeeSLC && canSeeMex);
  const showMexico = !canSeeMex ? false : (!canSeeSLC ? true : showMexicoState);

  return (
    <div className="space-y-6" data-testid="qc-pipeline-page">
      <header className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] tracking-[0.35em] uppercase text-[#A78BFA]">06 · QC Pipeline</div>
          <h1 className="font-heading font-bold text-4xl tracking-tight mt-2">Quality Pipeline</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Cross-department QC flow · {showMexico ? "MEXICO" : "SLC"} plant scope
          </p>
        </div>
        {canSeeSLC && canSeeMex ? (
          <button
            type="button" data-testid="qc-toggle-mexico"
            onClick={() => setShowMexico((v) => !v)}
            className={`px-3 py-2 text-[10px] tracking-widest uppercase font-mono border transition-colors ${
              showMexico ? "bg-[#FBBF24] text-[#0A0B10] border-[#FBBF24]" : "bg-[#12141D] text-muted-foreground border-border hover:text-white"
            }`}>
            {showMexico ? "Showing Mexico" : "Show Mexico Plants"}
          </button>
        ) : (
          <span
            className="px-3 py-2 text-[10px] tracking-widest uppercase font-mono border border-border bg-[#0A0B10] text-muted-foreground"
            data-testid="qc-plant-scope-locked">
            Plant: {canSeeMex ? "Mexico" : "SLC"} only
          </span>
        )}
      </header>

      <GfrcQcPipelineCard showMexico={showMexico} />
      <QcPostChecksCard showMexico={showMexico} />
      <FinalQcPipelineCard showMexico={showMexico} />
      <FinalQcAnalytics showMexico={showMexico} />
    </div>
  );
}
